import events from '../../bus/events'

/*
  Mapping of external subscription topics to an internal bus events
*/
export default {
  WS_SESSION: events.socket.session,
  REALITY_CHECK_PING: events.profile.realityCheck,
  CLIENT_VERIFICATION: events.profile.clientVerification,
  CLIENT_BALANCE: events.profile.balanceUpdate,
  CLIENT_BONUS_ACTIVATE: events.profile.bonusActivate,
  CLIENT_BONUS_DEACTIVATE: events.profile.bonusDeactivate,
  CLIENT_BONUS_STATUS: events.profile.bonusStatus,
  CLIENT_BONUS_ELIGIBILITY_STATUS: events.profile.bonusEligible,

  CLIENT_BUNDLE_ASSIGN: events.profile.bundleAssign,
  CLIENT_BUNDLE_DEACTIVATE: events.profile.bundleDeactivate,
  CLIENT_BUNDLE_STATUS: events.profile.bundleStatus,

  CLIENT_BETS_COUNT: events.profile.betsCountUpdate,
  CLIENT_BET_UPDATE: events.bet.updated,
  BALANCE_UPDATES: events.profile.balanceUpdate,
  DEPOSIT_COMPLETE: events.profile.depositComplete,
  CLIENT_LOGOUT: events.auth.logout,

  CLIENT_CONFIG_CHANGE: events.profile.clientConfigChange,

  GLOBAL_STATUS_UPDATES: events.global.providerStatusUpdate,

  SPORT_EVENT_COUNT: events.sport.sportEventsCount,
  CATEGORY_EVENT_COUNT: events.sport.categoryEventsCount,
  TOURNAMENT_EVENT_COUNT: events.sport.tournamentEventsCount,

  // Event update
  EXPERIMENTAL_EVENT: events.sport.eventUpdate,
  EXPERIMENTAL_TOURNAMENT: events.sport.tournamentUpdate,

  TOURNAMENT_SPORT_SERVICE_UPDATE: events.sport.tournamentEventSportServiceUpdate,

  PLACE_BET_SUCCESS_RESULT: 'no_use_this', // PLACE_BET_REQUEST_RESULT instead
  PLACE_BET_FAIL_RESULT: 'no_use_this', // PLACE_BET_REQUEST_RESULT instead
  PLACE_BET_REQUEST_RESULT: events.bet.placedResult,
  BET_INTERCEPTOR_RESOLUTION: events.bet.interceptResolve,

  RACING_RACE_UPDATE: events.racing.raceUpdate,
  RACING_ANY_RACE_STATUS_UPDATE: events.racing.raceStatusUpdate,

  SHOW_FLASH_MESSAGE: events.notification.showFlashMessage,
  SHOW_MODAL_WINDOW: events.notification.showModalWindow,

  BESPOKE_MARKET_UPDATE: events.bespokeMarket.update
}
